import { Grid, GridColumn, GridRow, ValueField } from '@bp/ui-components';
import { FragmentType, getFragmentData, graphql } from 'client/gql';
import { BpCard } from 'components/BpCard/BpCard';
import { useTranslation } from 'react-i18next';
import { AbsenceEvaluationMemberSummaryTable } from '../tables/AbsenceEvaluationMemberSummaryTable';

const AbsenceEvaluationMemberSummaryFragment = graphql(`
  fragment AbsenceEvaluationMemberSummaryFields on Query {
    absenceSummaryQuery(from: $from, to: $to, profileUuid: $memberUuid) {
      __typename
      profileUuid
      daysSum
      hoursSum
      fullyPresent
      percentage
      partialPresent
      fullyAbsent
      daysExcused
    }
    ...AbsenceEvaluationMemberSummaryTableFields
  }
`);

type AbsenceEvaluationMemberSummaryProps = {
  query: FragmentType<typeof AbsenceEvaluationMemberSummaryFragment> | undefined;
};

export const AbsenceEvaluationMemberSummary = ({ query }: AbsenceEvaluationMemberSummaryProps) => {
  const { t } = useTranslation();
  const fragment = getFragmentData(AbsenceEvaluationMemberSummaryFragment, query);
  const data = fragment?.absenceSummaryQuery[0] ?? {
    daysSum: 0,
    fullyPresent: 0,
    percentage: 100,
    partialPresent: 0,
    fullyAbsent: 0,
    daysExcused: 0,
  };

  return (
    <>
      <BpCard header={{ headline: t('common.days', { count: 2 }) }} className='mb-6'>
        <Grid useFormGap>
          <GridRow spacingTop='m'>
            <GridColumn width={3} offset='left'>
              <ValueField title={t('absences.evaluation.daysSum')}>{data.daysSum}</ValueField>
            </GridColumn>
            <GridColumn width={3}>
              <ValueField title={t('absences.evaluation.fullyPresent')}>{data.fullyPresent}</ValueField>
            </GridColumn>
            <GridColumn width={3} offset='right'>
              <ValueField title={t('common.percentage')}>{data.percentage}%</ValueField>
            </GridColumn>
          </GridRow>
          <GridRow>
            <GridColumn width={3} offset='left'>
              <ValueField title={t('absences.evaluation.partialPresent')}>{data.partialPresent}</ValueField>
            </GridColumn>
            <GridColumn width={3}>
              <ValueField title={t('absences.evaluation.fullyAbsent')}>{data.fullyAbsent}</ValueField>
            </GridColumn>
            <GridColumn width={3} offset='right'>
              <ValueField title={t('absences.evaluation.daysExcused')}>{data.daysExcused}</ValueField>
            </GridColumn>
          </GridRow>
        </Grid>
      </BpCard>

      <BpCard header={{ headline: `${t('common.subject')}/${t('courses.title')}` }} noPadding>
        <AbsenceEvaluationMemberSummaryTable query={fragment} />
      </BpCard>
    </>
  );
};
